<template>
    <div class="qksm qksm7">
        <h4>七、一般公共预算财政拨款“三公”经费支出决算情况说明</h4>
        <div class="nogap">
            <template v-if="num(T7.items_ys.三公总计) == 0 && num(T7.items.三公总计) == 0">
                <p><b>（一）“三公”经费支出决算总体情况及增减变动原因</b></p>
                <p>本{{$parent.typeText}}无一般公共预算安排的“三公”经费支出。</p>
            </template>
            <template v-else>
                <p><b>（一）“三公”经费支出决算总体情况说明</b></p>
                <p>
                    2020年度一般公共预算财政拨款“三公”经费支出年初预算为{{isMoney(T7.items_ys.三公总计)}}万元，支出决算为{{isMoney(T7.items.三公总计)}}万元，
                    <template v-if="num(T7.items.三公总计).toFixed(2)==num(T7.items_ys.三公总计).toFixed(2)">
                        与2020年预算基本持平，完成年初预算的100%。
                    </template>
                    <template v-else>
                        比年初预算{{growthValueText(T7.items.三公总计,T7.items_ys.三公总计)}}万元，
                        <template v-if="num(T7.items_ys.三公总计)!=0">
                            完成年初预算的{{calcRatio(T7.items.三公总计,T7.items_ys.三公总计)}}。
                        </template>
                        决算数{{num(T7.items.三公总计)>num(T7.items_ys.三公总计) ? "大于" : "小于"}}年初预算数的主要原因是
                        <reason type="textarea" classname="qksm widest because" name="三公支出原因" v-model:value="qksm['三公支出原因']"></reason>
                    </template>
                </p>
            </template>
            <p><b>（二）“三公”经费支出决算具体情况</b></p>
            <template v-if="$store.state.divData.zone=='yucheng'">
                <p class="tipsText hide_pdf">
                    <b>
                        备注：三公经费增减变化原因推荐以下几种模板：
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        增加：
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        （1）因公出国：按照××统一组织，经报×部门批准，我单位一行×人，赴×、×地区参加×、×活动，期间开支机票、住宿费、×等费用，导致因公出国（境）经费比上年增长×%。
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        （2）车辆购置：×年，按照×要求，我单位通过×方式采购×、×车辆×辆，导致我单位公务用车购置费比×年增长×%；
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        （3）公车运行维护费：×年，我单位增加×、×等公务活动，导致我单位公务用车运行维护费比×年增长×%；
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        （4）接待费：×年，因×（×部门到我市检查××工作）、×（开展招商引资活动）等，导致我单位公务接待费比×年增长×%；
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        减少：
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        1、我单位严格执行中央八项规定和省、市、县关于厉行节约、反对铺张浪费相关规定，遵守行公务用车定额标准和公务接待用餐标准，节俭部门开支。
                    </b>
                </p>
                <p class="tipsText hide_pdf">
                    <b>
                        2、2020年，按照机构改革方案，×单位从我单位划至×单位，导致我单位×费用减少。
                    </b>
                </p>
            </template>
            <template v-if="num(T7.items_ys.三公总计) == 0 && num(T7.items.三公总计) == 0">
                <p>1、因公出国（境）费决算数为0万元，因公出国（境）团组0个,累计0人次。</p>
                <p>2、公务用车购置及运行维护费决算数为0万元，其中：公务用车购置费支出0万元，2020年使用财政拨款购置公务用车0辆；公务用车运行维护费0万元，2020年财政拨款开支运行维护费的公务用车保有量为0辆。</p>
                <p>3、公务接待费决算数为0万元。其中：国内接待费0万元，共计接待0批次、0人次（含外事接待0批次、0人次）；国（境）外接待费0万元，共计接待0批次、0人次。</p>
            </template>
            <template v-else>
                <p>
                    1、因公出国（境）费年初预算为{{isMoney(T7.items_ys.因公出国)}}万元，支出决算为{{isMoney(T7.items.因公出国)}}万元，
                    <template v-if="num(T7.items.因公出国).toFixed(2)==num(T7.items_ys.因公出国).toFixed(2)">
                        与2020年预算基本持平
                        <template v-if="num(T7.items_ys.因公出国)!=0">
                            ，完成年初预算的100%
                        </template>
                        。
                    </template>
                    <template v-else>
                        比年初预算{{growthValueText(T7.items.因公出国,T7.items_ys.因公出国)}}万元，
                        <template v-if="num(T7.items_ys.因公出国)!=0">
                            完成年初预算的{{calcRatio(T7.items.因公出国,T7.items_ys.因公出国)}}。
                        </template>
                        决算数{{num(T7.items.因公出国)>num(T7.items_ys.因公出国) ? "大于" : "小于"}}年初预算数的主要原因是
                        <reason type="textarea" classname="qksm widest because" name="因公出国原因" v-model:value="qksm['因公出国原因']"></reason>
                    </template>
                    <template v-if="(num(T7.items_ys.因公出国) == 0 && num(T7.items.因公出国) == 0) || num(T7.items.因公出国)==0">
                        全年支出涉及因公出国（境）团组0个, 累计0人次。
                    </template>
                    <template v-else>
                        全年支出涉及因公出国（境）团组
                        <reason type="integer" classname="qksm integer" name="因公出国团组" v-model:value="qksm['因公出国团组']"></reason>个,
                        累计
                        <reason type="integer" classname="qksm integer" name="因公出国人次" v-model:value="qksm['因公出国人次']"></reason>人次。开支内容包括:
                        <reason type="textarea" classname="qksm widest" name="因公出国开支内容" v-model:value="qksm['因公出国开支内容']"></reason>
                    </template>
                </p>

                <p>
                    2、公务用车购置及运行维护费年初预算为{{isMoney(T7.items_ys.公务用车)}}万元，支出决算为{{isMoney(T7.items.公务用车)}}万元，
                    <template v-if="num(T7.items.公务用车).toFixed(2)==num(T7.items_ys.公务用车).toFixed(2)">
                        与2020年预算基本持平
                        <template v-if="num(T7.items_ys.公务用车)!=0">
                            ，完成年初预算的100%
                        </template>
                        。
                    </template>
                    <template v-else>
                        比年初预算{{growthValueText(T7.items.公务用车,T7.items_ys.公务用车)}}万元，
                        <template v-if="num(T7.items_ys.公务用车)!=0">
                            完成年初预算的{{calcRatio(T7.items.公务用车,T7.items_ys.公务用车)}}。
                        </template>
                        决算数{{num(T7.items.公务用车)>num(T7.items_ys.公务用车) ? "大于" : "小于"}}年初预算数的主要原因是
                        <reason type="textarea" classname="qksm widest because" name="公务用车原因" v-model:value="qksm['公务用车原因']"></reason>
                    </template>
                    其中：
                </p>
                <p>
                    公务用车购置费支出{{isMoney(T7.items.购置费)}}万元，2020年{{$store.state.divData.divname}}等单位使用财政拨款购置公务用车
                    <template v-if="num(T7.items.购置费)==0">
                        0
                    </template>
                    <reason v-else type="integer" classname="qksm integer" name="购置车辆" v-model:value="qksm['购置车辆']"></reason>辆。
                </p>
                <p>
                    公务用车运行维护费{{isMoney(T7.items.运行费)}}万元，
                    <span v-if="num(T7.items.运行费)!=0">
                        主要是按规定保留的公务用车的
                        <reason type="textarea" classname="qksm" name="保留公务用车" v-model:value="qksm['保留公务用车']"></reason>等支出。
                    </span>
                    截至2020年12月31日，{{$store.state.divData.divname}}等单位财政拨款开支运行维护费的公务用车保有量为
                    <reason type="integer" classname="qksm integer" name="车保有量" v-model:value="qksm['车保有量']"></reason>辆。
                </p>

                <p>
                    3、公务接待费年初预算为{{isMoney(T7.items_ys.公务接待)}}万元，支出决算为{{isMoney(T7.items.公务接待)}}万元，
                    <template v-if="num(T7.items.公务接待).toFixed(2)==num(T7.items_ys.公务接待).toFixed(2)">
                        与2020年预算基本持平
                        <template v-if="num(T7.items_ys.公务接待)!=0">
                            ，完成年初预算的100%
                        </template>
                        。
                    </template>
                    <template v-else>
                        比年初预算{{growthValueText(T7.items.公务接待,T7.items_ys.公务接待)}}万元，
                        <template v-if="num(T7.items_ys.公务接待)!=0">
                            完成年初预算的{{calcRatio(T7.items.公务接待,T7.items_ys.公务接待)}}。
                        </template>
                        决算数{{num(T7.items.公务接待)>num(T7.items_ys.公务接待) ? "大于" : "小于"}}年初预算数的主要原因是
                        <reason type="textarea" classname="qksm widest because" name="公务接待原因" v-model:value="qksm['公务接待原因']"></reason>
                    </template>
                    其中：
                </p>
                <p>
                    国内接待费<reason type="money" classname="qksm money" name="国内接待费" v-model:value="qksm['国内接待费']"></reason>万元，
                    <span v-if="isEmptyStr(qksm['国内接待费']) || num(qksm['国内接待费'])!=0">
                        主要用于<reason type="textarea" classname="qksm" name="国内接待主要用于" v-model:value="qksm['国内接待主要用于']"></reason>，
                    </span>
                    共计接待<reason type="integer" classname="qksm integer" name="国内接待批次" v-model:value="qksm['国内接待批次']"></reason>批次、
                    <reason type="integer" classname="qksm integer" name="国内接待人次" v-model:value="qksm['国内接待人次']"></reason>人次（含外事接待
                    <reason type="integer" classname="qksm integer" name="外事接待批次" v-model:value="qksm['外事接待批次']"></reason>批次、
                    <reason type="integer" classname="qksm integer" name="外事接待人次" v-model:value="qksm['外事接待人次']"></reason>人次）；
                </p>
                <p>
                    国（境）外接待费<reason type="money" classname="qksm money" name="国外接待费" v-model:value="qksm['国外接待费']"></reason>万元，
                    <span v-if="isEmptyStr(qksm['国外接待费']) || num(qksm['国外接待费'])!=0">
                        主要用于<reason type="textarea" classname="qksm" name="国外接待主要用于" v-model:value="qksm['国外接待主要用于']"></reason>，
                    </span>
                    共计接待<reason type="integer" classname="qksm integer" name="国外接待批次" v-model:value="qksm['国外接待批次']"></reason>批次、
                    <reason type="integer" classname="qksm integer" name="国外接待人次" v-model:value="qksm['国外接待人次']"></reason>人次。
                </p>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm7",
        data() {
            var qksm = this.$store.state.divData.qksm
            if (JSON.stringify(this.F03)!="{}") {
                qksm['因公出国团组'] = this.pickOneOf(qksm['因公出国团组'], this.num(this.F03["因公出国团组"]))
                qksm['因公出国人次'] = this.pickOneOf(qksm['因公出国人次'], this.num(this.F03["因公出国人次"]))
                qksm['购置车辆'] = this.pickOneOf(qksm['购置车辆'], this.num(this.F03["购置车辆"]))
                qksm['车保有量'] = this.pickOneOf(qksm['车保有量'], this.num(this.F03["车保有量"]))
                qksm['国内接待费'] = this.pickOneOf(qksm['国内接待费'], this.num(this.F03["国内接待费"]))
                qksm['国外接待费'] = this.pickOneOf(qksm['国外接待费'], this.num(this.F03["国外接待费"]))
                qksm['国内接待批次'] = this.pickOneOf(qksm['国内接待批次'], this.num(this.F03["国内批次"]))
                qksm['国内接待人次'] = this.pickOneOf(qksm['国内接待人次'], this.num(this.F03["国内人次"]))
                qksm['外事接待批次'] = this.pickOneOf(qksm['外事接待批次'], this.num(this.F03["外事批次"]))
                qksm['外事接待人次'] = this.pickOneOf(qksm['外事接待人次'], this.num(this.F03["外事人次"]))
                qksm['国外接待批次'] = this.pickOneOf(qksm['国外接待批次'], this.num(this.F03["国外批次"]))
                qksm['国外接待人次'] = this.pickOneOf(qksm['国外接待人次'], this.num(this.F03["国外人次"]))
            }

            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm
            }
        },

        props: {
            T7: {
                type: Object,
                default: "",
            },
            F03: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        watch: {
            'qksm.国内接待费'() {
                this.inspect()
            },
            'qksm.国外接待费'() {
                this.inspect()
            },
            'qksm.购置车辆'() {
                this.inspect()
            }
        },
        created() {
            this.inspect()
        },
        methods: {
            inspect() {
                if (this.num(this.T7.items.购置费) > 0 && this.num(this.qksm['购置车辆']) == 0) {
                    this.addOrSet("qksm91", "请检查本页《七、一般公共预算财政拨款“三公”经费支出决算情况说明（二）“三公”经费支出决算具体情况》，使用财政拨款购置公务用车应大于0辆。");
                } else {
                    this.remove("qksm91")
                }
                if (this.num(this.T7.items.公务接待).toFixed(2) != this.num(this.num(this.qksm['国内接待费']) + this.num(this.qksm['国外接待费'])).toFixed(2)) {
                    this.addOrSet("qksm9", "请检查本页《七、一般公共预算财政拨款“三公”经费支出决算情况说明（二）“三公”经费支出决算具体情况》，国内公务接待与国（境）外公务接待之和与公务接待费不相等。");
                } else {
                    this.remove("qksm9")
                }
            }
        }
    };
</script>